import React, { Component } from "react";
import { connect } from "react-redux";
import BaseTextField from "../../Base/ui/inputs/TextField";

class TextField extends Component {
  handleChange(e) {
    this.props.textDecorator
      ? this.props.handleChange(
          this.props.name,
          this.props.textDecorator(e.target.value)
        )
      : this.props.handleChange(this.props.name, e.target.value);
  }

  render() {
    const { resource, name, label, col, action, customValue } = this.props;
    const value = customValue ? customValue : this.props.value;

    return (
      <BaseTextField
        resource={resource}
        name={name}
        label={label}
        col={col}
        value={value}
        action={action}
        onChange={this.handleChange.bind(this)}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { resource = "resident", name } = ownProps;
  return {
    resource: resource,
    value: state[resource][name],
    action: ownProps.action || state.ui.action,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    handleChange: (name, value) =>
      dispatch({ type: "UPDATE_RESIDENT", payload: { name, value } }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TextField);
